import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserCandidateAssessment } from '../../../../redux/userOnboarding/action';
import { APIRequestStatus, LoadingStatus } from '../../../../constants/common';
import { CandidateFormFieldNames } from '../../../Recruiting/Constant/constant';
import TryAgain from '../../../molecules/ErrorState/error.component';
import { Box } from '@mui/material';
import CircularLoader from '../../../../atoms/CircularLoader/circular-loader';
import { FormHeader } from '../../common/formHeader';
import AccordionTabs from '../../../../atoms/Accordian/Accordian';
import CandidateAssessmentView from '../../../Recruiting/Outlet/CandidateDetailsOutlet/CandidateDetails/ManageCandidate/CandidateAssessment/CandidateAssessmentView';
import InterviewFeedbackForm from '../../../Recruiting/Outlet/CandidateDetailsOutlet/CandidateDetails/ManageCandidate/InterviewSchedule/Feedback/InterviewFeedbackForm';

const UserCandidateAssessment = (props) => {
  const { empId, username } = props;
  const {
    interviewConfig,
    feedbackConfig,
    interviewInfo,
    candidateInfo,
    requestProcessing: {
      [APIRequestStatus.GET_CANDIDATE_ASSESSMENT]: configLoadingStatus,
    },
  } = useSelector((state) => state.userOnboarding);

  const dispatch = useDispatch();
  const candidateName =
    candidateInfo?.fkCandidate?.[CandidateFormFieldNames.Name];
  const candidateCode =
    candidateInfo?.fkCandidate?.[CandidateFormFieldNames.Code];

  useEffect(() => {
    if (empId) {
      dispatch(getUserCandidateAssessment(empId));
    }
  }, [empId]);

  if (configLoadingStatus === LoadingStatus.Failure) {
    return <TryAgain />;
  }
  return (
    <Box>
      <CircularLoader show={configLoadingStatus === LoadingStatus.Loading} />
      <FormHeader
        title={candidateName || username ||  'User'}
        // labelCode={candidateCode || ''}
      />
      {interviewInfo?.map((item, index) => {
        const { competencies, skills, InterviewInfo, overall } = item;
        return (
          <div key={index}>
            <AccordionTabs
              key={index}
              title={InterviewInfo?.fkInterviewtype?.name || 'New Round'}
              tabDetails={
                <Box>
                  <CandidateAssessmentView
                    formConfig={interviewConfig}
                    formData={InterviewInfo}
                  />
                  <InterviewFeedbackForm
                    interviewFeedbackFormConfig={feedbackConfig}
                    competencies={competencies}
                    skills={skills}
                    interviewFeedbackFormInfo={overall}
                    viewMode={true}
                  />
                </Box>
              }
            />
          </div>
        );
      })}
    </Box>
  );
};

export default UserCandidateAssessment;
